import { render, staticRenderFns } from "./SuperMenu.vue?vue&type=template&id=387653fa&"
import script from "./SuperMenu.vue?vue&type=script&lang=js&"
export * from "./SuperMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports